(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/game-limits-deposits-form/assets/react/datetime-text.js') >= 0) return;  svs.modules.push('/components/accountservices-react/game-limits-deposits-form/assets/react/datetime-text.js');
'use strict';

const DateTimeText = _ref => {
  let datetime = _ref.datetime;
  const formattedDate = dateFns.format(new Date(datetime), 'd LLLL', {
    locale: dateFns.locales.sv
  });
  const formattedTime = dateFns.format(new Date(datetime), 'HH:mm', {
    locale: dateFns.locales.sv
  });
  return React.createElement("span", null, formattedDate, ", kl. ", formattedTime);
};
svs.accountservicesReact.gameLimitDepositsForm.DateTimeText = DateTimeText;

 })(window);